import Loadable from "react-loadable";

import { EmptyComponent } from "../../common/EmptyComponent";

export const OddsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/odds" */
      "./OddsSettings"
    ),
  loading: EmptyComponent
});

export const AppearanceSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/appearance" */
      "./AppearanceSettings"
    ),
  loading: EmptyComponent
});

export const LocalizationSettingsLoaderChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/localization" */
      "./LocalizationSettingsLoader"
    ),
  loading: EmptyComponent
});

export const LanguageSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/language" */
      "./LanguageSettings"
    ),
  loading: EmptyComponent
});

export const CountrySettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/country" */
      "./CountrySettings"
    ),
  loading: EmptyComponent
});

export const BiometricsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/biometrics" */
      "./BiometricsSettings"
    ),
  loading: EmptyComponent
});

export const NotificationsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/notifications" */
      "./NotificationsSettings"
    ),
  loading: EmptyComponent
});
